import { createSlice } from '@reduxjs/toolkit'
import { getActiveFilters } from 'utils/helpers'

const initialState = {
  grade_popup_data: null,
  gradebook_type: null,
  tableFilters: {
    summary: false,
    academic_year: null,
    academic_period: null,
    grade_level: null,
    group: null,
    group_course: null,
    course_component: null,
    student: null,
    date_assigned_from: null,
    date_assigned_to: null
  },
}

export const groupCourseGradebookUI = createSlice({
  name: 'groupCourseGradebookUI',
  initialState: initialState,
  reducers: {
    setGradePopupData: (state, { payload }) => {
      state.grade_popup_data = payload
    },
    setGradebookType: (state, { payload }) => {
      state.gradebook_type = payload
    },
    setSummary: (state, { payload }) => {
      state.tableFilters.summary = payload
    },
    setAcademicYear: (state, { payload }) => {
      state.tableFilters.academic_year = payload
    },
    setAcademicPeriod: (state, { payload }) => {
      state.tableFilters.academic_period = payload
    },
    setGradeYear: (state, { payload }) => {
      state.tableFilters.academic_year = payload
    },
    setGradeLevel: (state, { payload }) => {
      state.tableFilters.grade_level = payload
    },
    setGroup: (state, { payload }) => {
      state.tableFilters.group = payload
    },
    setGroupCourse: (state, { payload }) => {
      state.tableFilters.group_course = payload
    },
    setCourseComponent: (state, { payload }) => {
      state.tableFilters.course_component = payload
    },
    setStudent: (state, { payload }) => {
      state.tableFilters.student = payload
    },
    setDateAssignedFrom: (state, { payload }) => {
      state.tableFilters.date_assigned_from = payload
    },
    setDateAssignedTo: (state, { payload }) => {
      state.tableFilters.date_assigned_to = payload
    },
    trackActiveFilters: (state: any) => {
      state.activeFilters = getActiveFilters(initialState.tableFilters, state)
    },
    clearAllFilters: (state: any) => {
      state.tableFilters = initialState.tableFilters
      state.activeFilters = []
    },
  },
})

export const {
  setGradePopupData,
  setGradebookType,
  setSummary,
  setAcademicYear,
  setAcademicPeriod,
  setGradeLevel,
  setGroup,
  setGroupCourse,
  setCourseComponent,
  setStudent,
  setDateAssignedFrom,
  setDateAssignedTo,
  clearAllFilters,
} = groupCourseGradebookUI.actions

export default groupCourseGradebookUI.reducer
